var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoBlueCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H18C25.732 0 32 6.26801 32 14V18C32 25.732 25.732 32 18 32H14C6.26801 32 0 25.732 0 18V14Z",
    fill: "#5951EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 16.6666L22.1485 18.988C22.1987 19.0214 22.257 19.0405 22.3172 19.0434C22.3775 19.0463 22.4373 19.0328 22.4905 19.0043C22.5437 18.9759 22.5881 18.9335 22.6191 18.8818C22.6501 18.8301 22.6665 18.7709 22.6665 18.7106V13.2466C22.6665 13.188 22.6511 13.1304 22.6217 13.0796C22.5923 13.0288 22.5501 12.9867 22.4992 12.9575C22.4484 12.9283 22.3907 12.913 22.332 12.9132C22.2734 12.9134 22.2158 12.9291 22.1652 12.9586L18.6665 15",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 12H10.6668C9.93045 12 9.3335 12.597 9.3335 13.3333V18.6667C9.3335 19.403 9.93045 20 10.6668 20H17.3335C18.0699 20 18.6668 19.403 18.6668 18.6667V13.3333C18.6668 12.597 18.0699 12 17.3335 12Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoBlueCircle);
export default __webpack_public_path__ + "static/media/ic_video_blue_circle.18bb9e0cb321d59e29bb03efe53212c8.svg";
export { ForwardRef as ReactComponent };